import { render, staticRenderFns } from "./OrderStatusCard.vue?vue&type=template&id=5c31b2a0"
import script from "./OrderStatusCard.vue?vue&type=script&lang=js"
export * from "./OrderStatusCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports